// ------------------------------------
// Constants

import { HttpClient } from "../core/request";

// ------------------------------------
export const GIFTING_SHOW_WINDOW = "GIFTING_SHOW_WINDOW";
export const SET_GIFT = "SET_GIFT";
export const SET_DEAL_FOR_GIFT = "SET_DEAL_FOR_GIFT";
export const DELETE_GIFT = "DELETE_GIFT";
export const SET_PAST_RECIPIENTS = "SET_PAST_RECIPIENTS";

// ------------------------------------
// Actions
// ------------------------------------
export function changeGiftingModalVisible(show = false) {
  return {
    type: GIFTING_SHOW_WINDOW,
    payload: show,
  };
}

export function setGifts(gifts = []) {
  return {
    type: SET_GIFT,
    payload: gifts,
  };
}

export const setAddressBook = () => {
  return (dispatch, getState) => {
    HttpClient(true).get('gift/past_recipients').then(resp => {
      return dispatch({
        type: SET_PAST_RECIPIENTS,
        payload: resp.data
      })
    })
  }
}

// export function deleteGift(giftId) {
//   return {
//     type: DELETE_GIFT,
//     payload: giftId,
//   };
// }

export function deleteGift(giftId) {
  return (dispatch, getState) => {
    return HttpClient(true).delete('gift/'+giftId).then(resp => {
    }).catch(error => {
        console.log('Error', error)
    })
}
}

export function setDealForGift(dealForGift = {}) {
  return {
    type: SET_DEAL_FOR_GIFT,
    payload: dealForGift,
  };
}

export const postGift = (gift) => {
  return (dispatch, getState) => {
      return HttpClient(true).post('gift', gift).then(resp => {
          return resp.data
      }).catch(error => {
          console.log('Error', error)
          if (error.response.status >= 400 && error.response.status < 500) 
          return ({error: error.response.data.error})
      })
  }
};

export const editGift = (id, gift) => {
  return (dispatch, getState) => {
      return HttpClient(true).put('gift/'+id, gift).then(resp => {
          return resp.data
      })
      .catch(error => {
          console.log('Error', error)
          if (error.response.status >= 400 && error.response.status < 500) 
          return ({error: error.response.data.error})
      })
  }
};

// ------------------------------------
// Reducer
// ------------------------------------
export function giftingWindowReducer(state = false, action) {
  return action.type === GIFTING_SHOW_WINDOW ? action.payload : state;
}

export function pastRecipientsReducer(state = [], action) {
  return action.type === SET_PAST_RECIPIENTS ? action.payload : state;
}

export function giftReducer(state = [], action) {
  switch (action.type) {
    case SET_GIFT:
      return action.payload;
    case DELETE_GIFT:
      return state.filter((g) => g.id !== action.payload);
    default:
      return state;
  }
}

export function dealForGiftReducer(state = {}, action) {
  return action.type === SET_DEAL_FOR_GIFT ? action.payload : state;
}



// WEBPACK FOOTER //
// ./src/store/gifting.js